export enum SimulationDataSourceEnum {
	DATABLOCK = 'DATABLOCK',
	SUBSCRIPTION = 'DATALINK',
}

export type SimulationSortMode = 'asc' | 'desc';

export type SimulationSortColumn = {
	uuid: string;
	direction: SimulationSortMode;
};

export interface ISimulationPayload {
	simulation_data_source?: SimulationDataSourceEnum;
	profile_uuid?: string;
	column_template_uuid?: string;
	filter_template_uuids?: Array<string>;
	display_column_uuids?: Array<string>;
	sort_columns?: Array<SimulationSortColumn>;
}
export type SimulationResult = {
	data?: string;
	count?: number;
};

export interface ParsedSimulationResult {
	result: Array<Record<string, any>>;
	count: number;
}
